import { Modal } from 'components/modal/Modal';
import React, { Fragment, useCallback } from 'react';
import { loadStripe } from '@stripe/stripe-js';
import { EmbeddedCheckoutProvider, EmbeddedCheckout } from '@stripe/react-stripe-js';
import './ModalStripe.scss';
import { Button } from 'components/Button';
/**
 * @component ModalStripe
 * @since 1.0.0
 * @hidden
 */
export function ModalStripe(props) {
    var _a, _b, _c, _d;
    const { deal, onClose, directSale, hasDeposit, firstName, lastName, phone, location, onAlreadyPaid } = props;
    const stripePromise = loadStripe(((_a = deal === null || deal === void 0 ? void 0 : deal.paymentIntegration) === null || _a === void 0 ? void 0 : _a.key) || '', {
        stripeAccount: ((_b = deal === null || deal === void 0 ? void 0 : deal.paymentIntegration) === null || _b === void 0 ? void 0 : _b.accountId) || ''
    });
    const dealPaymentId = (_d = (_c = deal === null || deal === void 0 ? void 0 : deal.payments) === null || _c === void 0 ? void 0 : _c.find((payment) => {
        if (payment.status !== 'ACTIVE') {
            return false;
        }
        if (hasDeposit) {
            return payment.isDeposit === true;
        }
        return true;
    })) === null || _d === void 0 ? void 0 : _d.id;
    const fetchClientSecret = useCallback(() => {
        return fetch(process.env.API_URL_ROOT +
            '/stripe?id=' +
            dealPaymentId +
            '&directSale=' +
            directSale +
            '&hasDeposit=' +
            (hasDeposit ? 'true' : 'false'), {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ firstName, lastName, phone, location })
        })
            .then((res) => res.json())
            .then((data) => {
            if (data === null || data === void 0 ? void 0 : data.alreadyPaid) {
                onAlreadyPaid === null || onAlreadyPaid === void 0 ? void 0 : onAlreadyPaid();
                return new Promise(() => undefined);
            }
            return data.clientSecret;
        });
    }, [dealPaymentId, directSale, firstName, lastName, phone, location, hasDeposit, onAlreadyPaid]);
    const options = { fetchClientSecret };
    const footerActions = (React.createElement(Fragment, null,
        React.createElement(Button, { className: "button button--primary", onPress: onClose, label: t('Close') })));
    return (React.createElement("div", { className: "modal-stripe" },
        React.createElement(Modal, { title: t('Payment'), onClose: onClose, showFooterAction: true, footerActions: footerActions },
            React.createElement("div", { className: "modal-stripe-content" },
                React.createElement(EmbeddedCheckoutProvider, { stripe: stripePromise, options: options },
                    React.createElement(EmbeddedCheckout, null))))));
}
